import { Tag } from 'antd';
import { DefaultOptionType } from 'antd/es/cascader';
import {
  GameEnvType,
  IGameEnvModel,
  IApiGameEnvCollectionRes,
} from '../../../model/api-modules/env';
import { getConfig } from '../../../config';
import { ReactNode } from 'react';

const tagStyleLive = {
  background: '#E8FFEA',
  color: '#00B42A',
  borderRadius: '2px',
  marginLeft: '5px',
  marginRight: '2px',
};
const tagStyleDev = {
  background: '#FFFCE8',
  border: '1px solid rgb(247, 186, 30)',
  color: '#F7BA1E',
  borderRadius: '2px',
  marginLeft: '5px',
  marginRight: '2px',
};

export const formatEnvOptions = (envs: ReadonlyArray<IGameEnvModel>) => {
  const result = getConfig().gameConfig.region.reduce(
    (result: Array<DefaultOptionType>, item) => {
      const [label, value] = item;
      if (result) {
        const env = envs
          .filter((v) => v.Region === value)
          .map((v) =>
            Object.assign({}, v, {
              label: (
                <span>
                  {v.Type === GameEnvType.Live && (
                    <Tag style={tagStyleLive}>{v.Type}</Tag>
                  )}
                  {v.Type === GameEnvType.Dev && (
                    <Tag style={tagStyleDev}>{v.Type}</Tag>
                  )}
                  {v.Name}
                </span>
              ),
              value: v.id,
            })
          );
        if (env.length) {
          result.push({
            label,
            value,
            children: env,
          });
        }
      }
      return result;
    },
    []
  );
  return result;
};

export const formatEnvCollectionOptions = (
  envs: ReadonlyArray<IApiGameEnvCollectionRes>
) => {
  const result = getConfig().gameConfig.region.reduce(
    (
      result: Array<{
        label: ReactNode;
        value: string;
        children: Array<
          IApiGameEnvCollectionRes & { label: ReactNode; value: number }
        >;
      }>,
      item
    ) => {
      const [label, value] = item;
      if (result) {
        const env: Array<
          IApiGameEnvCollectionRes & { label: ReactNode; value: number }
        > =
          envs
            ?.filter((v) => v.envRegion === value)
            .map((v) =>
              Object.assign({}, v, {
                label: (
                  <span>
                    {v.envType === GameEnvType.Live && (
                      <Tag style={tagStyleLive}>{v.envType}</Tag>
                    )}
                    {v.envType === GameEnvType.Dev && (
                      <Tag style={tagStyleDev}>{v.envType}</Tag>
                    )}
                    {v.envName}
                  </span>
                ),
                value: v.envIncrementID,
              })
            ) || [];
        if (env.length) {
          result.push({
            label,
            value,
            children: env,
          });
        }
      }
      return result;
    },
    []
  );
  return result;
};

export const renderEnvDisplay = (
  labels: string[],
  selectedOptions?: DefaultOptionType[]
) => {
  return labels.map((label, i) => {
    const option = selectedOptions ? selectedOptions[i] : null;
    if (option) {
      let tagStyle = {};
      if (option?.Type === GameEnvType.Live) {
        tagStyle = tagStyleLive;
      } else if (option?.Type === GameEnvType.Dev) {
        tagStyle = tagStyleDev;
      }
      if (i === labels.length - 1) {
        return (
          <span key={option.value}>
            -{' '}
            <span
              className="option-name"
              title={option?.Name.length > 45 ? option?.Name : ''}
            >
              {option?.Name.length > 50
                ? `${option?.Name.slice(0, 33)}...`
                : option?.Name}
            </span>
            <Tag style={tagStyle} className={option?.Type?.toLowerCase()}>
              {option?.Type}
            </Tag>
          </span>
        );
      }
      return <span key={option.value}>{label} </span>;
    }
    return null;
  });
};
